module.exports = __webpack_public_path__ + "img/shenda.120d9945.png";